import {
  createComponentMapperModel,
  withCompInfo,
} from '@wix/editor-elements-integrations';
import type {
  IAccordionContainerDefinition,
  IAccordionContainerMapperProps,
  IAccordionContainerCarmiProps,
  IRawItem,
} from '../types';
import { DefaultOpened } from '../constants';
import {
  withSiteDirection,
  type LogicalAlignment,
} from '@wix/editor-elements-common-utils';

const calcOpened = (items: Array<IRawItem>, defaultOpened: DefaultOpened) => {
  const ids = items.map(({ id }) => id);

  switch (defaultOpened) {
    case DefaultOpened.OPEN_ALL:
      return ids;
    case DefaultOpened.OPEN_FIRST:
      return [ids[0]];
    case DefaultOpened.CLOSE_ALL:
    default:
      return [];
  }
};

export const props = withCompInfo<
  IAccordionContainerMapperProps,
  IAccordionContainerDefinition,
  IAccordionContainerCarmiProps
>()(
  ['compData', 'compProps', 'compStylableClass'],
  ({ compData, compProps, compStylableClass }, { containerRootClassName }) => {
    return {
      ...compData,
      ...compProps,
      multiple:
        compProps.defaultOpened === DefaultOpened.OPEN_ALL ||
        compProps.multiple,
      opened: calcOpened(compData.items, compProps.defaultOpened),
      stylableClassName: compStylableClass,
      containerRootClassName,
      direction: compData.direction,
    } as IAccordionContainerMapperProps;
  },
);

export const css = withCompInfo<any, IAccordionContainerDefinition>()(
  ['compProps', 'compData', 'styleProperties'],
  ({ compProps, compData, styleProperties }) => {
    const { animationTime } = compProps;
    const { direction = 'inherit' } = compData;
    const { align = 'start' } = styleProperties as Record<string, string> & {
      align: LogicalAlignment;
    };
    return {
      height: 'auto',
      'min-width': 'min-content',
      '--animation-time': animationTime,
      '--direction': withSiteDirection(direction),
      '--align': align,
    };
  },
);

export default createComponentMapperModel({ props, css });
